import React from 'react';
import Reflux from 'reflux';
import HighlightMixin from 'main/components/show/cuesheet/highlightCellMixin.js';
import PrintableCuesheetStore from 'flux/stores/cuesheet.printable/PrintableCuesheetStore';
import PrintableCuesheetActions from 'flux/actions/cuesheet.printable/PrintableCuesheetActions';
import CuesheetActions from 'flux/actions/cuesheet/CuesheetActions';
import EventViewActions from 'flux/actions/EventViewActions';
import EventViewStore from 'flux/stores/EventViewStore';
import TeamViewActions from 'flux/actions/TeamViewActions';
import ReadOnlyStore from 'flux/stores/ReadOnlyStore';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import EventShowListActions from 'flux/actions/EventShowListActions';
import classNames from 'classnames';
import { RowSizes } from 'shared/constants/Export';

import TableResizeContainer from 'main/components/show/cuesheet.printable/tableResizeContainer.jsx';
import PrintableTableHeader from 'main/components/show/cuesheet.printable/printableTableHeader.jsx';
import getPrintableTableBodies from 'main/components/show/cuesheet.printable/printableTableBodies.jsx';

require('style/main.printable');

export default React.createClass({
  displayName: 'PrintableCuesheetPage',

  mixins: [
    HighlightMixin,
    Reflux.connectFilter(ReadOnlyStore, 'readOnly', (st) => st.get('readOnly')),
    Reflux.connect(EventViewStore, 'event'),
    Reflux.connect(CuesheetStore, 'cue'),
    Reflux.connect(PrintableCuesheetStore, 'cuesheet'),
  ],

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  propTypes: {
    type: React.PropTypes.string,
    guest: React.PropTypes.bool,
  },

  getDefaultProps() {
    return {
      type: 'generic',
    };
  },

  componentDidMount() {
    const { teamId, eventId, showId } = this.context.router.state.params;

    PrintableCuesheetActions.setGuest(this.props.guest);

    if (this.props.guest) {
      CuesheetActions.populateForGuest(teamId, eventId, showId);
      EventViewActions.populateForGuest(teamId, eventId);
      TeamViewActions.populateForGuest(teamId);
      EventShowListActions.populateForGuest(teamId, eventId);
    } else {
      // for logged in users, these populate actions may have already been called to populate
      // the regular cuesheet. This is to prevent duplicating these actions if they have already
      // been called
      const { cue } = this.state;
      if (
        cue.get('showId') === showId &&
        cue.get('eventId') === eventId &&
        cue.get('teamId') === teamId &&
        cue.get('rows')
      )
        return;
      CuesheetActions.populate(teamId, eventId, showId);
      EventViewActions.populate(teamId, eventId);
      TeamViewActions.populate(teamId);
    }
  },

  render() {
    const { event, cuesheet } = this.state;

    const loading = cuesheet.get('loading');
    const team = cuesheet.get('team');
    const show = cuesheet.get('show');
    const settings = cuesheet.get('settings');
    const displayType = cuesheet.getIn(['show', 'displayType']);
    const columns = this._getColumns();

    if (!team || !event || !show || !settings || !columns || loading)
      return null;

    const { pageBreakEditingMode } = this.props;

    const pageBreaks = this.props.pageBreaks || cuesheet.get('pageBreaks');

    const displayClass = displayType === 'show' ? 'guest-cue' : 'guest-grid';

    const { location } = this.context.router.state;

    let classes = classNames(
      {
        'printable-cuesheet-global-element-manager': event.get(
          'globalElementManager',
        ),
      },
      displayClass,
    );

    if (
      location &&
      location.query &&
      location.query.rowSize === RowSizes.Comfortable
    ) {
      classes += ' printable-layout-size-loose';
    }

    const containerWidth = document.getElementById('pdf-preview-body')
      ? document.getElementById('pdf-preview-body').clientWidth
      : window.innerWidth;

    const tableWidth = this._getTableWidth();

    let scale = containerWidth / (tableWidth + 1);

    if (scale > 1) scale = 1;

    const translatePercentage = ((1 - scale) / 2) * -100;

    const scaleTable = window.location.href.indexOf('printable') === -1;

    const paddingBottom = 20 / scale > 20 ? 20 / scale : 20;

    const scaledWidth = scale === 1 ? '100%' : 0;

    const scaleStyles = scaleTable
      ? {
          transform: `translate(${translatePercentage}%, ${translatePercentage}%) scale(${scale})`,
          width: scaledWidth,
          paddingBottom: `${paddingBottom}px`,
          background: 'white',
        }
      : {};

    const grayscale = cuesheet.get('grayscale');

    const rowSizeClass = `rowSize-${cuesheet.get('rowSize')}`;

    const tableClasses = classNames(
      'pdf-export-table',
      { grayscale: grayscale },
      rowSizeClass,
    );

    const printableTableBodies = getPrintableTableBodies({
      pageBreakEditingMode,
      pageBreaks,
      userId: cuesheet.get('userId'),
      columns,
      rows: cuesheet.get('rows'),
      rowMap: cuesheet.get('rowMap'),
      show,
      twentyFourHourClock: event.get('twentyFourHourClock'),
      scale,
      tableWidth,
      includePrivateNoteContents: cuesheet.get('includePrivateNoteContents'),
    });

    const tableNode =
      this.props.type === 'export' ? (
        <table id="pdf-export-table" className={tableClasses}>
          <PrintableTableHeader
            guestColumns={columns}
            presetDurationDisplayType={show.get('presetDurationDisplayType')}
          />
          {printableTableBodies}
        </table>
      ) : (
        printableTableBodies.map((tableBody) => {
          return (
            <table className={tableClasses}>
              <PrintableTableHeader
                guestColumns={columns}
                presetDurationDisplayType={show.get(
                  'presetDurationDisplayType',
                )}
              />
              {tableBody}
            </table>
          );
        })
      );

    return cuesheet.get('cssZoom') ? (
      <div id="printable-cuesheet-table-container" className={classes}>
        <TableResizeContainer>{tableNode}</TableResizeContainer>
      </div>
    ) : (
      <div id="printable-cuesheet-table-container" className={classes}>
        <div style={scaleStyles}>{tableNode}</div>
      </div>
    );
  },

  _getPersonalColumns() {
    return this.state.cuesheet.get('columnsPersonal');
  },

  _getPersonalColumnsWidth() {
    return this.state.cuesheet.get('columnsPersonalWidth');
  },

  _getGuestColumns() {
    return this.state.cuesheet.get('columnsGuest');
  },

  _getGuestColumnsWidth() {
    return this.state.cuesheet.get('columnsGuestWidth');
  },

  _getCustomColumns() {
    return this.state.cuesheet.get('columnsCustom');
  },

  _getCustomColumnsWidth() {
    return this.state.cuesheet.get('columnsCustomWidth');
  },

  _getGenericColumns() {
    return this.state.cuesheet.get('columnsGeneric');
  },

  _getGenericColumnsWidth() {
    return this.state.cuesheet.get('columnsGenericWidth');
  },

  _getExportColumns() {
    return this.state.cuesheet.get('columnsExport');
  },

  _getExportColumnsWidth() {
    return this.state.cuesheet.get('columnsExportWidth');
  },

  _getColumns() {
    let type = this.props.type || 'generic';

    if (this.props.guest) type = 'guest';

    const columnLookup = {
      personal: this._getPersonalColumns(),
      generic: this._getGenericColumns(),
      custom: this._getCustomColumns(),
      guest: this._getGuestColumns(),
      export: this._getExportColumns(),
    };

    return columnLookup[type];
  },

  _getTableWidth() {
    const type = this.props.type || 'generic';

    const tableWidthLookup = {
      personal: this._getPersonalColumnsWidth(),
      generic: this._getGenericColumnsWidth(),
      custom: this._getCustomColumnsWidth(),
      guest: this._getGuestColumnsWidth(),
      export: this._getExportColumnsWidth(),
    };

    return tableWidthLookup[type];
  },
});
